import { apiGet, apiPost, apiDelete } from "./apiClient";

export const getSavedFilter = (employeeId, candidateId) => {
  return apiGet(`/api/saved_filters/get?employeeId=${employeeId}&candidateId=${candidateId}`);
};

export const saveFilter = (employeeId, candidateId, filter) => {
  return apiPost(`/api/saved_filters/save?employeeId=${employeeId}&candidateId=${candidateId}`, filter);
};

export const deleteSavedFilter = (employeeId, candidateId) => {
  return apiDelete(`/api/saved_filters/delete?employeeId=${employeeId}&candidateId=${candidateId}`);
};
